const googleConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY_ID,
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  discoveryDocs: ['https://people.googleapis.com/$discovery/rest?version=v1'],
  scopes: 'openid profile email',
};

export default googleConfig;
